<template>
    <div>
        <div>
            <!-- 模块切换 -->
            <el-tabs v-model="activeTab" @tab-click="handleTabChange" style="margin-bottom: 15px;">
                <el-tab-pane label="套餐管理" name="package"></el-tab-pane>
                <el-tab-pane label="配餐计划" name="plan"></el-tab-pane>
                <el-tab-pane label="长者订单" name="order"></el-tab-pane>
            </el-tabs>

            <!-- 套餐管理模块 -->
            <div v-if="activeTab === 'package'">
                <el-row>
                    <!-- 工具条 -->
                    <el-form :inline="true" :model="packageFormInline" class="demo-form-inline toolbar"
                        @submit.native.prevent>
                        <el-form-item label="套餐名称">
                            <el-input clearable v-model.trim="packageFormInline.packageName" placeholder="请输入套餐名称"
                                style="width: 200px;" @keyup.enter.native.prevent="packageSearch"></el-input>
                        </el-form-item>
                        <el-form-item label="套餐状态">
                            <el-select v-model="packageFormInline.status" style="width: 140px" clearable>
                                <el-option value="" label="全部"></el-option>
                                <el-option value="1" label="启用"></el-option>
                                <el-option value="0" label="禁用"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" @click="packageSearch" plain>查询</el-button>
                            <el-button type="success" icon="el-icon-plus" @click="addPackage" plain>新增套餐</el-button>
                            <el-button type="info" @click="packageDownReport" icon="el-icon-download" plain
                                style="margin-left: 10px">套餐报表导出</el-button>
                        </el-form-item>
                    </el-form>

                    <!-- 套餐列表表格 -->
                    <el-table style="width: 100%" :data="packageTableData" v-loading="packageTableLoading"
                        ref="packageTable" :header-cell-style="{
                            'text-align': 'center',
                            'font-size': '16px',
                            'font-weight': '600',
                            color: '#2d2d2d',
                            'background-color': '#d4f5fa',
                        }" :cell-style="{ 'text-align': 'center', 'font-size': '16px' }" :row-style="tableRowStyle">
                        <el-table-column prop="packageName" label="套餐名称" min-width="150"></el-table-column>
                        <el-table-column prop="packageDesc" label="套餐描述" min-width="200"></el-table-column>
                        <el-table-column prop="menuDetail" label="菜谱明细" min-width="250"></el-table-column>
                        <el-table-column prop="price" label="套餐价格" min-width="100"
                            :formatter="formatPrice"></el-table-column>
                        <el-table-column prop="status" label="套餐状态" min-width="100"
                            :formatter="formatPackageStatus"></el-table-column>
                        <el-table-column prop="createTime" label="创建时间" min-width="160"></el-table-column>
                        <el-table-column label="操作" min-width="180">
                            <template slot-scope="scope">
                                <el-button type="warning" size="mini" plain
                                    @click="editPackage(scope.row)">编辑</el-button>
                                <el-button style="margin-left: 2px" type="danger" size="mini" plain
                                    @click="deletePackage(scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                    <!-- 分页组件 -->
                    <el-pagination background @size-change="packageHandleSizeChange"
                        @current-change="packageHandleCurrentChange" :current-page="packageCurrentPage"
                        layout="total, prev, pager, next" :total="packageTotalDataNumber" :page-size="packagePageSize"
                        align="center" class="fenye"></el-pagination>
                </el-row>

                <!-- 新增/编辑套餐弹窗 -->
                <el-dialog :title="isPackageEdit ? '编辑套餐' : '新增套餐'" width="60%" :visible.sync="packageFormVisible"
                    :close-on-click-modal="false" :close-on-press-escape="false">
                    <el-form ref="packageForm" :model="packageForm" :rules="packageFormRules" label-width="120px">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="套餐名称" prop="packageName">
                                    <el-input v-model="packageForm.packageName" placeholder="请输入套餐名称"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="套餐价格" prop="price">
                                    <el-input v-model="packageForm.price" type="number" min="0" step="0.01"
                                        placeholder="请输入套餐价格"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="套餐描述" prop="packageDesc">
                                    <el-input v-model="packageForm.packageDesc" type="textarea" :rows="2"
                                        placeholder="请描述套餐特点（如：低盐低脂、含1荤2素1汤）"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="菜谱明细" prop="menuDetail">
                                    <el-input v-model="packageForm.menuDetail" type="textarea" :rows="3"
                                        placeholder="请输入菜谱明细（如：清蒸鱼+清炒时蔬+番茄蛋汤+米饭）"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" v-if="isPackageEdit">
                                <el-form-item label="套餐状态" prop="status">
                                    <el-select v-model="packageForm.status" placeholder="请选择套餐状态">
                                        <el-option value="1" label="启用"></el-option>
                                        <el-option value="0" label="禁用"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                    <div slot="footer" class="dialog-footer" align="center">
                        <el-button @click="packageFormVisible = false">取消</el-button>
                        <el-button type="primary" @click="submitPackageForm">确定</el-button>
                    </div>
                </el-dialog>

                <!-- 套餐导出字段选择弹窗 -->
                <el-dialog title="导出字段选择" width="420px" :visible.sync="packageFieldsVisible"
                    :close-on-click-modal="false" :close-on-press-escape="false" @close="packageCloseFieldsDialog">
                    <el-checkbox :indeterminate="packageIsIndeterminate" v-model="packageCheckAll"
                        @change="packageHandleCheckAllChange">全选</el-checkbox>
                    <div style="margin: 15px 0"></div>
                    <el-checkbox-group v-model="packageSelectedFields" @change="packageHandleCheckedFieldsChange"
                        style="display: flex; flex-wrap: wrap; width: 100%">
                        <el-checkbox v-for="item in packageExportFields" :label="item.value" :key="item.value"
                            size="medium" :disabled="item.required" style="width: 42%">{{ item.label }}</el-checkbox>
                    </el-checkbox-group>
                    <div slot="footer" class="dialog-footer" align="center">
                        <el-button @click="packageFieldsVisible = false">取消</el-button>
                        <el-button type="primary" @click="packageConfirmExport">确认导出</el-button>
                    </div>
                </el-dialog>
            </div>

            <!-- 配餐计划模块 -->
            <div v-if="activeTab === 'plan'">
                <el-row>
                    <!-- 工具条 -->
                    <el-form :inline="true" :model="planFormInline" class="demo-form-inline toolbar"
                        @submit.native.prevent>
                        <el-form-item label="计划日期">
                            <el-date-picker v-model="planFormInline.planDate" type="date" placeholder="选择计划日期"
                                value-format="yyyy-MM-dd" style="width: 180px;"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="餐次">
                            <el-select v-model="planFormInline.mealPeriod" style="width: 120px" clearable>
                                <el-option value="" label="全部"></el-option>
                                <el-option value="早餐" label="早餐"></el-option>
                                <el-option value="午餐" label="午餐"></el-option>
                                <el-option value="晚餐" label="晚餐"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="套餐名称">
                            <el-select v-model="planFormInline.packageId" style="width: 180px" clearable filterable
                                remote :remote-method="getPackageList" placeholder="搜索套餐">
                                <el-option v-for="item in packageOptions" :key="item.id" :label="item.packageName"
                                    :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="计划状态">
                            <el-select v-model="planFormInline.status" style="width: 140px" clearable>
                                <el-option value="" label="全部"></el-option>
                                <el-option value="1" label="可预订"></el-option>
                                <el-option value="2" label="已截止"></el-option>
                                <el-option value="3" label="已取消"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" @click="planSearch" plain>查询</el-button>
                            <el-button type="success" icon="el-icon-plus" @click="addPlan" plain>新增计划</el-button>
                            <el-button type="info" @click="copyPlan" icon="el-icon-copy" plain
                                style="margin-left: 10px">复制计划</el-button>
                            <el-button type="info" @click="planDownReport" icon="el-icon-download" plain
                                style="margin-left: 10px">计划报表导出</el-button>
                        </el-form-item>
                    </el-form>

                    <!-- 配餐计划列表表格 -->
                    <el-table style="width: 100%" :data="planTableData" v-loading="planTableLoading" ref="planTable"
                        :header-cell-style="{
                            'text-align': 'center',
                            'font-size': '16px',
                            'font-weight': '600',
                            color: '#2d2d2d',
                            'background-color': '#d4f5fa',
                        }" :cell-style="{ 'text-align': 'center', 'font-size': '16px' }" :row-style="tableRowStyle">
                        <el-table-column prop="planDate" label="计划日期" min-width="120"></el-table-column>
                        <el-table-column prop="mealPeriod" label="餐次" min-width="80"></el-table-column>
                        <el-table-column prop="packageName" label="套餐名称" min-width="150"></el-table-column>
                        <el-table-column prop="planNum" label="计划份数" min-width="100"></el-table-column>
                        <el-table-column prop="usedNum" label="已订份数" min-width="100"></el-table-column>
                        <el-table-column prop="status" label="计划状态" min-width="100"
                            :formatter="formatPlanStatus"></el-table-column>
                        <el-table-column prop="createTime" label="创建时间" min-width="160"></el-table-column>
                        <el-table-column label="操作" min-width="220">
                            <template slot-scope="scope">
                                <el-button type="warning" size="mini" plain @click="editPlan(scope.row)">编辑</el-button>
                                <el-button style="margin-left: 2px" type="danger" size="mini" plain
                                    @click="deletePlan(scope.row)">删除</el-button>
                                <el-button style="margin-left: 2px" type="primary" size="mini" plain
                                    @click="updatePlanStatus(scope.row)">变更状态</el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                    <!-- 分页组件 -->
                    <el-pagination background @size-change="planHandleSizeChange"
                        @current-change="planHandleCurrentChange" :current-page="planCurrentPage"
                        layout="total, prev, pager, next" :total="planTotalDataNumber" :page-size="planPageSize"
                        align="center" class="fenye"></el-pagination>
                </el-row>

                <!-- 新增/编辑配餐计划弹窗 -->
                <el-dialog :title="isPlanEdit ? '编辑配餐计划' : '新增配餐计划'" width="60%" :visible.sync="planFormVisible"
                    :close-on-click-modal="false" :close-on-press-escape="false">
                    <el-form ref="planForm" :model="planForm" :rules="planFormRules" label-width="120px">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="计划日期" prop="planDate">
                                    <el-date-picker v-model="planForm.planDate" type="date" placeholder="选择计划日期"
                                        value-format="yyyy-MM-dd"></el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="餐次" prop="mealPeriod">
                                    <el-select v-model="planForm.mealPeriod" placeholder="请选择餐次">
                                        <el-option value="早餐" label="早餐"></el-option>
                                        <el-option value="午餐" label="午餐"></el-option>
                                        <el-option value="晚餐" label="晚餐"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="套餐选择" prop="packageId">
                                    <el-select v-model="planForm.packageId" style="width: 100%" filterable remote
                                        :remote-method="getPackageList" placeholder="搜索套餐">
                                        <el-option v-for="item in packageOptions" :key="item.id"
                                            :label="item.packageName" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="计划份数" prop="planNum">
                                    <el-input v-model="planForm.planNum" type="number" min="1"
                                        placeholder="请输入计划供应份数"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" v-if="isPlanEdit">
                                <el-form-item label="计划状态" prop="status">
                                    <el-select v-model="planForm.status" placeholder="请选择计划状态">
                                        <el-option value="1" label="可预订"></el-option>
                                        <el-option value="2" label="已截止"></el-option>
                                        <el-option value="3" label="已取消"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                    <div slot="footer" class="dialog-footer" align="center">
                        <el-button @click="planFormVisible = false">取消</el-button>
                        <el-button type="primary" @click="submitPlanForm">确定</el-button>
                    </div>
                </el-dialog>

                <!-- 复制计划弹窗 -->
                <el-dialog title="复制配餐计划" width="40%" :visible.sync="copyPlanVisible" :close-on-click-modal="false"
                    :close-on-press-escape="false">
                    <el-form ref="copyPlanForm" :model="copyPlanForm" :rules="copyPlanRules" label-width="120px">
                        <el-form-item label="原计划日期" prop="oldDate">
                            <el-date-picker v-model="copyPlanForm.oldDate" type="date" placeholder="选择要复制的日期"
                                value-format="yyyy-MM-dd"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="新计划日期" prop="newDate">
                            <el-date-picker v-model="copyPlanForm.newDate" type="date" placeholder="选择复制到的日期"
                                value-format="yyyy-MM-dd"></el-date-picker>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer" align="center">
                        <el-button @click="copyPlanVisible = false">取消</el-button>
                        <el-button type="primary" @click="submitCopyPlan">确认复制</el-button>
                    </div>
                </el-dialog>

                <!-- 计划状态变更弹窗 -->
                <el-dialog title="变更计划状态" width="30%" :visible.sync="planStatusVisible" :close-on-click-modal="false"
                    :close-on-press-escape="false">
                    <el-form ref="planStatusForm" :model="planStatusForm" :rules="planStatusRules" label-width="100px">
                        <el-form-item label="目标状态" prop="status">
                            <el-select v-model="planStatusForm.status" placeholder="请选择目标状态">
                                <el-option value="1" label="可预订"></el-option>
                                <el-option value="2" label="已截止"></el-option>
                                <el-option value="3" label="已取消"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer" align="center">
                        <el-button @click="planStatusVisible = false">取消</el-button>
                        <el-button type="primary" @click="submitPlanStatus">确认变更</el-button>
                    </div>
                </el-dialog>

                <!-- 计划导出字段选择弹窗 -->
                <el-dialog title="导出字段选择" width="420px" :visible.sync="planFieldsVisible" :close-on-click-modal="false"
                    :close-on-press-escape="false" @close="planCloseFieldsDialog">
                    <el-checkbox :indeterminate="planIsIndeterminate" v-model="planCheckAll"
                        @change="planHandleCheckAllChange">全选</el-checkbox>
                    <div style="margin: 15px 0"></div>
                    <el-checkbox-group v-model="planSelectedFields" @change="planHandleCheckedFieldsChange"
                        style="display: flex; flex-wrap: wrap; width: 100%">
                        <el-checkbox v-for="item in planExportFields" :label="item.value" :key="item.value"
                            size="medium" :disabled="item.required" style="width: 42%">{{ item.label }}</el-checkbox>
                    </el-checkbox-group>
                    <div slot="footer" class="dialog-footer" align="center">
                        <el-button @click="planFieldsVisible = false">取消</el-button>
                        <el-button type="primary" @click="planConfirmExport">确认导出</el-button>
                    </div>
                </el-dialog>
            </div>

            <!-- 长者订单模块 -->
            <div v-if="activeTab === 'order'">
                <el-row>
                    <!-- 工具条 -->
                    <el-form :inline="true" :model="orderFormInline" class="demo-form-inline toolbar"
                        @submit.native.prevent>
                        <el-form-item label="长者姓名">
                            <el-input clearable v-model.trim="orderFormInline.elderlyName" placeholder="请输入长者姓名"
                                style="width: 150px;" @keyup.enter.native.prevent="orderSearch"></el-input>
                        </el-form-item>
                        <el-form-item label="就餐日期">
                            <el-date-picker v-model="orderFormInline.mealDate" type="date" placeholder="选择就餐日期"
                                value-format="yyyy-MM-dd" style="width: 180px;"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="餐次">
                            <el-select v-model="orderFormInline.mealPeriod" style="width: 120px" clearable>
                                <el-option value="" label="全部"></el-option>
                                <el-option value="早餐" label="早餐"></el-option>
                                <el-option value="午餐" label="午餐"></el-option>
                                <el-option value="晚餐" label="晚餐"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="订单状态">
                            <el-select v-model="orderFormInline.orderStatus" style="width: 140px" clearable>
                                <el-option value="" label="全部"></el-option>
                                <el-option value="1" label="待就餐"></el-option>
                                <el-option value="2" label="已就餐"></el-option>
                                <el-option value="3" label="已取消"></el-option>
                                <el-option value="4" label="已退款"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" @click="orderSearch" plain>查询</el-button>
                            <el-button type="success" icon="el-icon-plus" @click="addOrder" plain>新增订单</el-button>
                            <el-button type="info" @click="orderDownReport" icon="el-icon-download" plain
                                style="margin-left: 10px">订单报表导出</el-button>
                        </el-form-item>
                    </el-form>

                    <!-- 长者订单列表表格 -->
                    <el-table style="width: 100%" :data="orderTableData" v-loading="orderTableLoading" ref="orderTable"
                        :header-cell-style="{
                            'text-align': 'center',
                            'font-size': '16px',
                            'font-weight': '600',
                            color: '#2d2d2d',
                            'background-color': '#d4f5fa',
                        }" :cell-style="{ 'text-align': 'center', 'font-size': '16px' }" :row-style="tableRowStyle">
                        <el-table-column prop="orderNo" label="订单编号" min-width="180"></el-table-column>
                        <el-table-column prop="elderlyName" label="长者姓名" min-width="120"></el-table-column>
                        <el-table-column prop="elderlyPhone" label="联系电话" min-width="120"></el-table-column>
                        <el-table-column prop="communityName" label="所属社区" min-width="150"></el-table-column>
                        <el-table-column prop="mealDate" label="就餐日期" min-width="120"></el-table-column>
                        <el-table-column prop="mealPeriod" label="餐次" min-width="80"></el-table-column>
                        <el-table-column prop="packageName" label="套餐名称" min-width="150"></el-table-column>
                        <el-table-column prop="actualAmount" label="实付金额" min-width="100"
                            :formatter="formatPrice"></el-table-column>
                        <el-table-column prop="diningType" label="就餐方式" min-width="120"
                            :formatter="formatDiningType"></el-table-column>
                        <el-table-column prop="orderStatus" label="订单状态" min-width="120"
                            :formatter="formatOrderStatus"></el-table-column>
                        <el-table-column prop="createTime" label="下单时间" min-width="160"></el-table-column>
                        <el-table-column label="操作" min-width="220">
                            <template slot-scope="scope">
                                <el-button type="primary" size="mini" plain @click="updateOrderStatus(scope.row, 2)"
                                    v-if="scope.row.orderStatus === 1">确认就餐</el-button>
                                <el-button style="margin-left: 2px" type="danger" size="mini" plain
                                    @click="cancelOrder(scope.row)" v-if="scope.row.orderStatus === 1">取消订单</el-button>
                                <el-button style="margin-left: 2px" type="info" size="mini" plain
                                    @click="viewOrderDetail(scope.row)">查看详情</el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                    <!-- 分页组件 -->
                    <el-pagination background @size-change="orderHandleSizeChange"
                        @current-change="orderHandleCurrentChange" :current-page="orderCurrentPage"
                        layout="total, prev, pager, next" :total="orderTotalDataNumber" :page-size="orderPageSize"
                        align="center" class="fenye"></el-pagination>
                </el-row>

                <!-- 新增订单弹窗 -->
                <el-dialog title="新增长者订单" width="70%" :visible.sync="orderFormVisible" :close-on-click-modal="false"
                    :close-on-press-escape="false">
                    <el-form ref="orderForm" :model="orderForm" :rules="orderFormRules" label-width="120px">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="长者姓名" prop="elderlyName">
                                    <el-input v-model="orderForm.elderlyName" placeholder="请输入长者姓名"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="联系电话" prop="elderlyPhone">
                                    <el-input v-model="orderForm.elderlyPhone" placeholder="请输入联系电话"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="就餐日期" prop="mealDate">
                                    <el-date-picker v-model="orderForm.mealDate" type="date" placeholder="选择就餐日期"
                                        value-format="yyyy-MM-dd"></el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="餐次" prop="mealPeriod">
                                    <el-select v-model="orderForm.mealPeriod" placeholder="请选择餐次">
                                        <el-option value="早餐" label="早餐"></el-option>
                                        <el-option value="午餐" label="午餐"></el-option>
                                        <el-option value="晚餐" label="晚餐"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="配餐计划" prop="planId">
                                    <el-select v-model="orderForm.planId" style="width: 100%" filterable remote
                                        :remote-method="getPlanList" placeholder="搜索配餐计划">
                                        <el-option v-for="item in planOptions" :key="item.id"
                                            :label="`${item.planDate} ${item.mealPeriod} - ${item.packageName}`"
                                            :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="就餐方式" prop="diningType">
                                    <el-select v-model="orderForm.diningType" placeholder="请选择就餐方式">
                                        <el-option value="1" label="堂食"></el-option>
                                        <el-option value="2" label="送餐上门"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="补贴金额" prop="subsidyAmount">
                                    <el-input v-model="orderForm.subsidyAmount" type="number" min="0" step="0.01"
                                        placeholder="请输入补贴金额（默认0）"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="实付金额" prop="actualAmount" :disabled="true">
                                    <el-input v-model="orderForm.actualAmount" placeholder="自动计算"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" v-if="orderForm.diningType === 2">
                                <el-form-item label="送餐地址" prop="deliveryAddress">
                                    <el-input v-model="orderForm.deliveryAddress" placeholder="请输入送餐地址"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="备注">
                                    <el-input v-model="orderForm.remark" type="textarea" :rows="2"
                                        placeholder="请输入备注信息（如：少盐、餐具自备）"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                    <div slot="footer" class="dialog-footer" align="center">
                        <el-button @click="orderFormVisible = false">取消</el-button>
                        <el-button type="primary" @click="submitOrderForm">提交订单</el-button>
                    </div>
                </el-dialog>

                <!-- 订单详情弹窗 -->
                <el-dialog title="订单详情" width="60%" :visible.sync="orderDetailVisible" :close-on-click-modal="false"
                    :close-on-press-escape="false">
                    <el-form :model="orderDetail" label-width="140px" class="detail-form">
                        <el-row :gutter="30">
                            <el-col :span="12">
                                <el-form-item label="订单编号">
                                    <span>{{ orderDetail.orderNo || '-' }}</span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="长者姓名">
                                    <span>{{ orderDetail.elderlyName || '-' }}</span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="联系电话">
                                    <span>{{ orderDetail.elderlyPhone || '-' }}</span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="所属社区">
                                    <span>{{ orderDetail.communityName || '-' }}</span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="就餐日期">
                                    <span>{{ orderDetail.mealDate || '-' }}</span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="餐次">
                                    <span>{{ orderDetail.mealPeriod || '-' }}</span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="套餐名称">
                                    <span>{{ orderDetail.packageName || '-' }}</span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="订单金额">
                                    <span>{{ formatPriceDetail(orderDetail.amount) }}</span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="补贴金额">
                                    <span>{{ formatPriceDetail(orderDetail.subsidyAmount) }}</span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="实付金额">
                                    <span>{{ formatPriceDetail(orderDetail.actualAmount) }}</span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="就餐方式">
                                    <span>{{ formatDiningTypeDetail(orderDetail.diningType) }}</span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="订单状态">
                                    <span>{{ formatOrderStatusDetail(orderDetail.orderStatus) }}</span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" v-if="orderDetail.deliveryAddress">
                                <el-form-item label="送餐地址">
                                    <span>{{ orderDetail.deliveryAddress }}</span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="备注">
                                    <span>{{ orderDetail.remark || '无' }}</span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="下单时间">
                                    <span>{{ orderDetail.createTime || '-' }}</span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="更新时间">
                                    <span>{{ orderDetail.updateTime || '-' }}</span>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                    <div slot="footer" class="dialog-footer" align="center">
                        <el-button @click="orderDetailVisible = false">关闭</el-button>
                    </div>
                </el-dialog>

                <!-- 订单导出字段选择弹窗 -->
                <el-dialog title="导出字段选择" width="420px" :visible.sync="orderFieldsVisible" :close-on-click-modal="false"
                    :close-on-press-escape="false" @close="orderCloseFieldsDialog">
                    <el-checkbox :indeterminate="orderIsIndeterminate" v-model="orderCheckAll"
                        @change="orderHandleCheckAllChange">全选</el-checkbox>
                    <div style="margin: 15px 0"></div>
                    <el-checkbox-group v-model="orderSelectedFields" @change="orderHandleCheckedFieldsChange"
                        style="display: flex; flex-wrap: wrap; width: 100%">
                        <el-checkbox v-for="item in orderExportFields" :label="item.value" :key="item.value"
                            size="medium" :disabled="item.required" style="width: 42%">{{ item.label }}</el-checkbox>
                    </el-checkbox-group>
                    <div slot="footer" class="dialog-footer" align="center">
                        <el-button @click="orderFieldsVisible = false">取消</el-button>
                        <el-button type="primary" @click="orderConfirmExport">确认导出</el-button>
                    </div>
                </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>
import bus from "@/vuex/eventBus";
import { baseURL } from "@/utils/request.js";

export default {
    name: "CanteenMealManagement",
    data() {
        return {
            // 模块切换
            activeTab: "package",

            // 套餐管理相关
            packageFormInline: {
                packageName: "",
                status: ""
            },
            packageTableData: [],
            packageTableLoading: false,
            packageCurrentPage: 1,
            packagePageNo: 1,
            packagePageSize: 10,
            packageTotalDataNumber: 0,
            packageFormVisible: false,
            isPackageEdit: false,
            packageForm: {
                id: null,
                packageName: "",
                packageDesc: "",
                price: 0,
                menuDetail: "",
                status: 1
            },
            packageFormRules: {
                packageName: [
                    { required: true, message: "请输入套餐名称", trigger: "blur" }
                ],
                price: [
                    { required: true, message: "请输入套餐价格", trigger: "blur" },
                ],
                menuDetail: [
                    { required: true, message: "请输入菜谱明细", trigger: "blur" }
                ]
            },
            packageExportFields: [
                { value: "packageName", label: "套餐名称", required: true },
                { value: "packageDesc", label: "套餐描述" },
                { value: "menuDetail", label: "菜谱明细", required: true },
                { value: "price", label: "套餐价格", required: true },
                { value: "status", label: "套餐状态" },
                { value: "createTime", label: "创建时间" }
            ],
            packageSelectedFields: ["packageName", "menuDetail", "price"],
            packageCheckAll: false,
            packageIsIndeterminate: true,
            packageFieldsVisible: false,

            // 配餐计划相关
            planFormInline: {
                planDate: "",
                mealPeriod: "",
                packageId: "",
                status: ""
            },
            planTableData: [],
            planTableLoading: false,
            planCurrentPage: 1,
            planPageNo: 1,
            planPageSize: 10,
            planTotalDataNumber: 0,
            planFormVisible: false,
            isPlanEdit: false,
            planForm: {
                id: null,
                planDate: "",
                mealPeriod: "",
                packageId: "",
                planNum: 0,
                status: 1
            },
            planFormRules: {
                planDate: [
                    { required: true, message: "请选择计划日期", trigger: "change" }
                ],
                mealPeriod: [
                    { required: true, message: "请选择餐次", trigger: "change" }
                ],
                packageId: [
                    { required: true, message: "请选择套餐", trigger: "change" }
                ],
                planNum: [
                    { required: true, message: "请输入计划份数", trigger: "blur" },
                ]
            },
            copyPlanVisible: false,
            copyPlanForm: {
                oldDate: "",
                newDate: ""
            },
            copyPlanRules: {
                oldDate: [
                    { required: true, message: "请选择原计划日期", trigger: "change" }
                ],
                newDate: [
                    { required: true, message: "请选择新计划日期", trigger: "change" }
                ]
            },
            planStatusVisible: false,
            planStatusForm: {
                id: null,
                status: ""
            },
            planStatusRules: {
                status: [
                    { required: true, message: "请选择目标状态", trigger: "change" }
                ]
            },
            planExportFields: [
                { value: "planDate", label: "计划日期", required: true },
                { value: "mealPeriod", label: "餐次", required: true },
                { value: "packageName", label: "套餐名称", required: true },
                { value: "planNum", label: "计划份数" },
                { value: "usedNum", label: "已订份数" },
                { value: "status", label: "计划状态" },
                { value: "createTime", label: "创建时间" }
            ],
            planSelectedFields: ["planDate", "mealPeriod", "packageName", "planNum"],
            planCheckAll: false,
            planIsIndeterminate: true,
            planFieldsVisible: false,

            // 长者订单相关
            orderFormInline: {
                elderlyName: "",
                mealDate: "",
                mealPeriod: "",
                orderStatus: ""
            },
            orderTableData: [],
            orderTableLoading: false,
            orderCurrentPage: 1,
            orderPageNo: 1,
            orderPageSize: 10,
            orderTotalDataNumber: 0,
            orderFormVisible: false,
            orderForm: {
                id: null,
                elderlyId: "",
                elderlyName: "",
                elderlyPhone: "",
                communityId: "",
                communityName: "",
                planId: "",
                packageId: "",
                packageName: "",
                mealDate: "",
                mealPeriod: "",
                amount: 0,
                subsidyAmount: 0,
                actualAmount: 0,
                orderStatus: 1,
                diningType: 1,
                deliveryAddress: "",
                remark: ""
            },
            orderFormRules: {
                elderlyName: [
                    { required: true, message: "请输入长者姓名", trigger: "blur" }
                ],
                elderlyPhone: [
                    { required: true, message: "请输入联系电话", trigger: "blur" }
                ],
                communityId: [
                    { required: true, message: "请输入社区ID", trigger: "blur" }
                ],
                communityName: [
                    { required: true, message: "请输入社区名称", trigger: "blur" }
                ],
                mealDate: [
                    { required: true, message: "请选择就餐日期", trigger: "change" }
                ],
                mealPeriod: [
                    { required: true, message: "请选择餐次", trigger: "change" }
                ],
                planId: [
                    { required: true, message: "请选择配餐计划", trigger: "change" }
                ],
                diningType: [
                    { required: true, message: "请选择就餐方式", trigger: "change" }
                ],
                deliveryAddress: [
                    { required: true, message: "请输入送餐地址", trigger: "blur" }
                ]
            },
            orderDetailVisible: false,
            orderDetail: {},
            orderExportFields: [
                { value: "orderNo", label: "订单编号", required: true },
                { value: "elderlyName", label: "长者姓名", required: true },
                { value: "elderlyPhone", label: "联系电话" },
                { value: "communityName", label: "所属社区" },
                { value: "mealDate", label: "就餐日期", required: true },
                { value: "mealPeriod", label: "餐次", required: true },
                { value: "packageName", label: "套餐名称", required: true },
                { value: "amount", label: "订单金额" },
                { value: "subsidyAmount", label: "补贴金额" },
                { value: "actualAmount", label: "实付金额", required: true },
                { value: "diningType", label: "就餐方式" },
                { value: "orderStatus", label: "订单状态", required: true },
                { value: "createTime", label: "下单时间" }
            ],
            orderSelectedFields: ["orderNo", "elderlyName", "mealDate", "packageName", "actualAmount", "orderStatus"],
            orderCheckAll: false,
            orderIsIndeterminate: true,
            orderFieldsVisible: false,

            // 下拉选项
            packageOptions: [],
            planOptions: []
        };
    },

    methods: {
        // 表格行样式
        tableRowStyle({ row, rowIndex }) {
            return rowIndex % 2 === 0
                ? { "background-color": "#ffffff" }
                : { "background-color": "#e4f5f8" };
        },

        // 格式化价格
        formatPrice(row, column) {
            const value = column ? row[column.prop] : row;
            return value ? `¥${value.toFixed(2)}` : "¥0.00";
        },

        // 格式化套餐状态
        formatPackageStatus(row) {
            return row.status === 1 ? "启用" : "禁用";
        },

        // 格式化配餐计划状态
        formatPlanStatus(row) {
            const statusMap = { 1: "可预订", 2: "已截止", 3: "已取消" };
            return statusMap[row.status] || "未知";
        },

        // 格式化就餐方式
        formatDiningType(row) {
            return row.diningType === 1 ? "堂食" : "送餐上门";
        },

        // 格式化订单状态
        formatOrderStatus(row) {
            const statusMap = { 1: "待就餐", 2: "已就餐", 3: "已取消", 4: "已退款" };
            return statusMap[row.orderStatus] || "未知";
        },

        // 详情页格式化价格
        formatPriceDetail(value) {
            return value ? `¥${value.toFixed(2)}` : "¥0.00";
        },

        // 详情页格式化就餐方式
        formatDiningTypeDetail(value) {
            return value === 1 ? "堂食" : value === 2 ? "送餐上门" : "-";
        },

        // 详情页格式化订单状态
        formatOrderStatusDetail(value) {
            const statusMap = { 1: "待就餐", 2: "已就餐", 3: "已取消", 4: "已退款" };
            return statusMap[value] || "-";
        },

        // 模块切换
        handleTabChange(tab) {
            const tabName = tab.name;
            if (tabName === "package") {
                this.queryPackageList();
            } else if (tabName === "plan") {
                this.getPackageList();
                this.queryPlanList();
            } else if (tabName === "order") {
                this.queryOrderList();
            }
        },

        // ------------------------------ 套餐管理 ------------------------------
        // 套餐搜索
        packageSearch() {
            this.packagePageNo = 1;
            this.queryPackageList();
        },

        // 套餐分页大小变更
        packageHandleSizeChange(val) {
            this.packagePageSize = val;
            this.queryPackageList();
        },

        // 套餐当前页变更
        packageHandleCurrentChange(val) {
            this.packagePageNo = val;
            this.queryPackageList();
        },

        // 查询套餐列表
        queryPackageList() {
            this.packageTableLoading = true;
            const params = {
                ...this.packageFormInline,
                pageNo: this.packagePageNo,
                pageSize: this.packagePageSize
            };

            this.$postJson("omc/canteenPackage/show", params).then(res => {
                this.packageTableLoading = false;
                if (res.code === 200) {
                    this.packageTableData = res.result.list || [];
                    this.packageTotalDataNumber = Number(res.result.total) || 0;
                    this.packageCurrentPage = res.result.pageNum || 1;
                } else {
                    this.$message.error(res.message || "套餐查询失败");
                    this.packageTableData = [];
                    this.packageTotalDataNumber = 0;
                }
            }).catch(() => {
                this.packageTableLoading = false;
                this.packageTableData = [];
                this.packageTotalDataNumber = 0;
            });
        },

        // 新增套餐
        addPackage() {
            this.isPackageEdit = false;
            this.packageForm = {
                id: null,
                packageName: "",
                packageDesc: "",
                price: 0,
                menuDetail: "",
                status: 1
            };
            this.packageFormVisible = true;
        },

        // 编辑套餐
        editPackage(row) {
            this.isPackageEdit = true;
            this.packageForm = { ...row };
            this.packageFormVisible = true;
        },

        // 删除套餐
        deletePackage(row) {
            this.$confirm(`确定要删除套餐【${row.packageName}】吗？`, "提示", {
                type: "warning"
            }).then(() => {
                this.$postJson("omc/canteenPackage/delete", { id: row.id }).then(res => {
                    if (res.code === 200) {
                        this.$message.success("删除成功");
                        this.queryPackageList();
                    } else {
                        this.$message.error(res.message || "删除失败");
                    }
                });
            }).catch(() => {
                this.$message.info("已取消删除");
            });
        },

        // 提交套餐表单
        submitPackageForm() {
            this.$refs.packageForm.validate(valid => {
                if (valid) {
                    const url = this.isPackageEdit ? "omc/canteenPackage/update" : "omc/canteenPackage/add";
                    this.$postJson(url, this.packageForm).then(res => {
                        if (res.code === 200) {
                            this.$message.success(this.isPackageEdit ? "编辑成功" : "新增成功");
                            this.packageFormVisible = false;
                            this.queryPackageList();
                        } else {
                            this.$message.error(res.message || "操作失败");
                        }
                    });
                }
            });
        },

        // 套餐导出
        packageDownReport() {
            this.packageFieldsVisible = true;
        },

        // 套餐全选处理
        packageHandleCheckAllChange(val) {
            this.packageSelectedFields = val
                ? this.packageExportFields.map(item => item.value)
                : this.packageExportFields.filter(item => item.required).map(item => item.value);
            this.packageIsIndeterminate = false;
        },

        // 套餐字段选择变化
        packageHandleCheckedFieldsChange(value) {
            const requiredLength = this.packageExportFields.filter(item => item.required).length;
            this.packageCheckAll = value.length === this.packageExportFields.length;
            this.packageIsIndeterminate = value.length > requiredLength && value.length < this.packageExportFields.length;
        },

        // 套餐关闭字段选择弹窗
        packageCloseFieldsDialog() {
            const requiredFields = this.packageExportFields.filter(item => item.required).map(item => item.value);
            this.packageSelectedFields = [...new Set([...requiredFields, ...this.packageSelectedFields])];
        },

        // 套餐确认导出
        packageConfirmExport() {
            const params = new URLSearchParams();
            params.append("fields", this.packageSelectedFields.join(","));
            Object.entries(this.packageFormInline).forEach(([key, val]) => {
                if (val) params.append(key, val);
            });

            window.location.href = `${baseURL}omc/canteenPackage/export?${params.toString()}`;
            this.packageFieldsVisible = false;
        },

        // ------------------------------ 配餐计划管理 ------------------------------
        // 获取套餐列表（下拉选择）
        getPackageList(query = "") {
            this.$postJson("omc/canteenPackage/show", { packageName: query, pageSize: 100 }).then(res => {
                if (res.code === 200) {
                    this.packageOptions = res.result.list || [];
                }
            });
        },

        // 配餐计划搜索
        planSearch() {
            this.planPageNo = 1;
            this.queryPlanList();
        },

        // 配餐计划分页大小变更
        planHandleSizeChange(val) {
            this.planPageSize = val;
            this.queryPlanList();
        },

        // 配餐计划当前页变更
        planHandleCurrentChange(val) {
            this.planPageNo = val;
            this.queryPlanList();
        },

        // 查询配餐计划列表
        queryPlanList() {
            this.planTableLoading = true;
            const params = {
                ...this.planFormInline,
                pageNo: this.planPageNo,
                pageSize: this.planPageSize
            };

            this.$postJson("omc/canteenMealPlan/show", params).then(res => {
                this.planTableLoading = false;
                if (res.code === 200) {
                    this.planTableData = res.result.list || [];
                    this.planTotalDataNumber = Number(res.result.total) || 0;
                    this.planCurrentPage = res.result.pageNum || 1;
                } else {
                    this.$message.error(res.message || "配餐计划查询失败");
                    this.planTableData = [];
                    this.planTotalDataNumber = 0;
                }
            }).catch(() => {
                this.planTableLoading = false;
                this.planTableData = [];
                this.planTotalDataNumber = 0;
            });
        },

        // 新增配餐计划
        addPlan() {
            this.isPlanEdit = false;
            this.planForm = {
                id: null,
                planDate: "",
                mealPeriod: "",
                packageId: "",
                planNum: 0,
                status: 1
            };
            this.planFormVisible = true;
        },

        // 编辑配餐计划
        editPlan(row) {
            this.isPlanEdit = true;
            this.planForm = { ...row };
            this.planFormVisible = true;
        },

        // 删除配餐计划
        deletePlan(row) {
            this.$confirm(`确定要删除【${row.planDate} ${row.mealPeriod}】的配餐计划吗？`, "提示", {
                type: "warning"
            }).then(() => {
                this.$postJson("omc/canteenMealPlan/delete", { id: row.id }).then(res => {
                    if (res.code === 200) {
                        this.$message.success("删除成功");
                        this.queryPlanList();
                    } else {
                        this.$message.error(res.message || "删除失败");
                    }
                });
            }).catch(() => {
                this.$message.info("已取消删除");
            });
        },

        // 复制配餐计划
        copyPlan() {
            this.copyPlanForm = {
                oldDate: "",
                newDate: ""
            };
            this.copyPlanVisible = true;
        },

        // 提交复制计划
        submitCopyPlan() {
            this.$refs.copyPlanForm.validate(valid => {
                if (valid) {
                    this.$postJson("omc/canteenMealPlan/copy", this.copyPlanForm).then(res => {
                        if (res.code === 200) {
                            this.$message.success(`成功复制${res.result.copyCount}条计划`);
                            this.copyPlanVisible = false;
                            this.queryPlanList();
                        } else {
                            this.$message.error(res.message || "复制失败");
                        }
                    });
                }
            });
        },

        // 变更计划状态
        updatePlanStatus(row) {
            this.planStatusForm = {
                id: row.id,
                status: row.status
            };
            this.planStatusVisible = true;
        },

        // 提交计划状态变更
        submitPlanStatus() {
            this.$refs.planStatusForm.validate(valid => {
                if (valid) {
                    this.$postJson("omc/canteenMealPlan/update", {
                        id: this.planStatusForm.id,
                        status: this.planStatusForm.status
                    }).then(res => {
                        if (res.code === 200) {
                            this.$message.success("状态变更成功");
                            this.planStatusVisible = false;
                            this.queryPlanList();
                        } else {
                            this.$message.error(res.message || "状态变更失败");
                        }
                    });
                }
            });
        },

        // 提交配餐计划表单
        submitPlanForm() {
            this.$refs.planForm.validate(valid => {
                if (valid) {
                    const url = this.isPlanEdit ? "omc/canteenMealPlan/update" : "omc/canteenMealPlan/add";
                    this.$postJson(url, this.planForm).then(res => {
                        if (res.code === 200) {
                            this.$message.success(this.isPlanEdit ? "编辑成功" : "新增成功");
                            this.planFormVisible = false;
                            this.queryPlanList();
                        } else {
                            this.$message.error(res.message || "操作失败");
                        }
                    });
                }
            });
        },

        // 配餐计划导出
        planDownReport() {
            this.planFieldsVisible = true;
        },

        // 配餐计划全选处理
        planHandleCheckAllChange(val) {
            this.planSelectedFields = val
                ? this.planExportFields.map(item => item.value)
                : this.planExportFields.filter(item => item.required).map(item => item.value);
            this.planIsIndeterminate = false;
        },

        // 配餐计划字段选择变化
        planHandleCheckedFieldsChange(value) {
            const requiredLength = this.planExportFields.filter(item => item.required).length;
            this.planCheckAll = value.length === this.planExportFields.length;
            this.planIsIndeterminate = value.length > requiredLength && value.length < this.planExportFields.length;
        },

        // 配餐计划关闭字段选择弹窗
        planCloseFieldsDialog() {
            const requiredFields = this.planExportFields.filter(item => item.required).map(item => item.value);
            this.planSelectedFields = [...new Set([...requiredFields, ...this.planSelectedFields])];
        },

        // 配餐计划确认导出
        planConfirmExport() {
            const params = new URLSearchParams();
            params.append("fields", this.planSelectedFields.join(","));
            Object.entries(this.planFormInline).forEach(([key, val]) => {
                if (val) params.append(key, val);
            });

            window.location.href = `${baseURL}omc/canteenMealPlan/export?${params.toString()}`;
            this.planFieldsVisible = false;
        },

        // ------------------------------ 长者订单管理 ------------------------------
        // 获取配餐计划列表（下拉选择）
        getPlanList(query = "") {
            const params = {
                mealDate: this.orderForm.mealDate,
                mealPeriod: this.orderForm.mealPeriod,
                packageName: query,
                status: 1,
                pageSize: 100
            };
            this.$postJson("omc/canteenMealPlan/show", params).then(res => {
                if (res.code === 200) {
                    this.planOptions = res.result.list || [];
                }
            });
        },

        // 订单搜索
        orderSearch() {
            this.orderPageNo = 1;
            this.queryOrderList();
        },

        // 订单分页大小变更
        orderHandleSizeChange(val) {
            this.orderPageSize = val;
            this.queryOrderList();
        },

        // 订单当前页变更
        orderHandleCurrentChange(val) {
            this.orderPageNo = val;
            this.queryOrderList();
        },

        // 查询订单列表
        queryOrderList() {
            this.orderTableLoading = true;
            const params = {
                ...this.orderFormInline,
                pageNo: this.orderPageNo,
                pageSize: this.orderPageSize,
                communityId: sessionStorage.getItem("communityId") || ""
            };

            this.$postJson("omc/canteenElderlyOrder/show", params).then(res => {
                this.orderTableLoading = false;
                if (res.code === 200) {
                    this.orderTableData = res.result.list || [];
                    this.orderTotalDataNumber = Number(res.result.total) || 0;
                    this.orderCurrentPage = res.result.pageNum || 1;
                } else {
                    this.$message.error(res.message || "订单查询失败");
                    this.orderTableData = [];
                    this.orderTotalDataNumber = 0;
                }
            }).catch(() => {
                this.orderTableLoading = false;
                this.orderTableData = [];
                this.orderTotalDataNumber = 0;
            });
        },

        // 新增订单
        addOrder() {
            this.orderForm = {
                id: null,
                elderlyId: "",
                elderlyName: "",
                elderlyPhone: "",
                communityId: sessionStorage.getItem("communityId") || "",
                communityName: sessionStorage.getItem("communityName") || "",
                planId: "",
                packageId: "",
                packageName: "",
                mealDate: "",
                mealPeriod: "",
                amount: 0,
                subsidyAmount: 0,
                actualAmount: 0,
                orderStatus: 1,
                diningType: 1,
                deliveryAddress: "",
                remark: ""
            };
            this.orderFormVisible = true;
        },

        // 提交订单表单
        submitOrderForm() {
            this.$refs.orderForm.validate(valid => {
                if (valid) {
                    // 获取套餐价格计算金额
                    const selectedPlan = this.planOptions.find(item => item.id === this.orderForm.planId);
                    if (selectedPlan) {
                        this.orderForm.amount = selectedPlan.packagePrice || 0;
                        this.orderForm.actualAmount = this.orderForm.amount - this.orderForm.subsidyAmount;
                        this.orderForm.packageId = selectedPlan.packageId;
                        this.orderForm.packageName = selectedPlan.packageName;
                        this.orderForm.mealDate = selectedPlan.planDate;
                        this.orderForm.mealPeriod = selectedPlan.mealPeriod;
                    }

                    this.$postJson("omc/canteenElderlyOrder/add", this.orderForm).then(res => {
                        if (res.code === 200) {
                            this.$message.success("订单提交成功");
                            this.orderFormVisible = false;
                            this.queryOrderList();
                        } else {
                            this.$message.error(res.message || "订单提交失败");
                        }
                    });
                }
            });
        },

        // 确认就餐
        updateOrderStatus(row, status) {
            this.$confirm(`确定要将订单【${row.orderNo}】状态改为${status === 2 ? "已就餐" : "已退款"}吗？`, "提示", {
                type: "info"
            }).then(() => {
                this.$postJson("omc/canteenElderlyOrder/update", {
                    id: row.id,
                    orderStatus: status
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success("状态更新成功");
                        this.queryOrderList();
                    } else {
                        this.$message.error(res.message || "状态更新失败");
                    }
                });
            }).catch(() => {
                this.$message.info("已取消操作");
            });
        },

        // 取消订单
        cancelOrder(row) {
            this.$confirm(`确定要取消订单【${row.orderNo}】吗？`, "提示", {
                type: "warning"
            }).then(() => {
                this.$postJson("omc/canteenElderlyOrder/cancel", { id: row.id }).then(res => {
                    if (res.code === 200) {
                        this.$message.success("订单取消成功");
                        this.queryOrderList();
                    } else {
                        this.$message.error(res.message || "订单取消失败");
                    }
                });
            }).catch(() => {
                this.$message.info("已取消操作");
            });
        },

        // 查看订单详情
        viewOrderDetail(row) {
            this.orderDetail = { ...row };
            this.orderDetailVisible = true;
        },

        // 订单导出
        orderDownReport() {
            this.orderFieldsVisible = true;
        },

        // 订单全选处理
        orderHandleCheckAllChange(val) {
            this.orderSelectedFields = val
                ? this.orderExportFields.map(item => item.value)
                : this.orderExportFields.filter(item => item.required).map(item => item.value);
            this.orderIsIndeterminate = false;
        },

        // 订单字段选择变化
        orderHandleCheckedFieldsChange(value) {
            const requiredLength = this.orderExportFields.filter(item => item.required).length;
            this.orderCheckAll = value.length === this.orderExportFields.length;
            this.orderIsIndeterminate = value.length > requiredLength && value.length < this.orderExportFields.length;
        },

        // 订单关闭字段选择弹窗
        orderCloseFieldsDialog() {
            const requiredFields = this.orderExportFields.filter(item => item.required).map(item => item.value);
            this.orderSelectedFields = [...new Set([...requiredFields, ...this.orderSelectedFields])];
        },
        // 订单确认导出
        orderConfirmExport() {
            const params = new URLSearchParams();
            params.append("communityId", sessionStorage.getItem("communityId") || "");
            params.append("fields", this.orderSelectedFields.join(","));
            Object.entries(this.orderFormInline).forEach(([key, val]) => { if (val) params.append(key, val); });
        },
        // watch: {// 监听订单表单的补贴金额变化，自动计算实付金额
        //     "orderForm.subsidyAmount": function (newVal) {
        //         if (this.orderForm.amount) {
        //             this.orderForm.actualAmount = Math.max(0, this.orderForm.amount - (newVal || 0));
        //         }
        //     },// 监听订单表单的配餐计划变化，获取套餐价格
        //     "orderForm.planId": function (newVal) {
        //         if (newVal) {
        //             const selectedPlan = this.planOptions.find(item => item.id === newVal); if (selectedPlan) {
        //                 this.orderForm.amount = selectedPlan.packagePrice || 0;
        //                 this.orderForm.actualAmount = Math.max(0, this.orderForm.amount - (this.orderForm.subsidyAmount || 0));
        //                 this.orderForm.packageId = selectedPlan.packageId; this.orderForm.packageName = selectedPlan.packageName;
        //             }
        //         }
        //     },
        //     // 监听订单表单的就餐方式变化，控制送餐地址必填项
        //     "orderForm.diningType": function (newVal) {
        //         const deliveryRule = this.orderFormRules.deliveryAddress; if (newVal === 2) {
        //             // 送餐上门时，送餐地址必填
        //             this.orderFormRules.deliveryAddress = [{ required: true, message: "请输入送餐地址", trigger: "blur" }];
        //         } else {// 堂食时，送餐地址非必填
        //             this.orderFormRules.deliveryAddress = [];
        //         }
        //     }
        // },
        mounted() {// 初始化默认加载套餐管理列表
            this.queryPackageList();// 监听详情页返回刷新this.
            bus.on("refreshCanteenList", () => {
                if (this.activeTab === "package") {
                    this.queryPackageList();
                } else if (this.activeTab === "plan") { this.queryPlanList(); } else if (
                    this.activeTab === "order") {
                    this.queryOrderList();
                }
            });
        },
        beforeDestroy() {
            this.
                bus.
                off("refreshCanteenList");
        }
    }
}
</script>
<style lang="scss" scoped>
.toolbar {
    padding: 10px 0 10px 10px;
    background: #fff;
    border-radius: 4px 4px 0 0;
}

.fenye {
    padding: 20px 0;
    background: #fff;
    border-radius: 0 0 4px 4px;
}

::v-deep .el-dialog__header {
    padding: 15px 20px;
    border-bottom: 1px solid #eee;
}

::v-deep .el-dialog__footer {
    padding: 15px 20px;
    border-top: 1px solid #eee;
}

::v-deep .el-form-item {
    margin-bottom: 15px;
}

::v-deep .el-tabs__header {
    border-bottom: 1px solid #e4e7ed;
    margin-bottom: 15px;
}

::v-deep .el-tabs__item {
    font-size: 16px;
    padding: 0 20px;
}

::v-deep .el-tabs__active-bar {
    height: 3px;
    background-color: #1890ff;
}

.detail-form {
    ::v-deep .el-form-item {
        margin-bottom: 12px;

        ::v-deep .el-form-item__label {
            font-weight: 500;
            color: #333;
        }

        ::v-deep .el-form-item__content {
            color: #666;
            font-size: 15px;
        }
    }
}
</style>
